export default __webpack_public_path__ + "static/media/19.3403cbe5.jpg";